<template>
  <b-card no-body class="card-profile" img-src="img/theme/img-1-1000x600.jpg" alt="Image placeholder" img-top>
    <b-row class="justify-content-center">
      <b-col lg="3" class="order-lg-2">
        <!-- <div class="card-profile-image">
          <a href="#">
            <b-img src="img/theme/team-4.jpg" rounded="circle" />
          </a>
        </div> -->
      </b-col>
    </b-row>

    <b-card-header class="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
      <!-- <div class="d-flex justify-content-between">
        <a href="#" class="btn btn-sm btn-info mr-4">Connect</a>
        <a href="#" class="btn btn-sm btn-default float-right">Message</a>
      </div> -->
    </b-card-header>

    <b-card-body class="pt-0">
      <b-row>
        <!-- <b-col >
          <div class="card-profile-stats d-flex justify-content-center">
            <div>
              <span class="heading">22</span>
              <span class="description">Friends</span>
            </div>
            <div>
              <span class="heading">10</span>
              <span class="description">Photos</span>
            </div>
            <div>
              <span class="heading">89</span>
              <span class="description">Comments</span>
            </div>
          </div>
        </b-col> -->
      </b-row>
      <div class="text-center">
        <h5 class="h3">
          {{getUserInfo.firstName}} {{getUserInfo.lastName}}<span class="font-weight-light">, {{getUserInfo.dob | getAge}}</span>
        </h5>
        <div class="h5 font-weight-300">
          <i class="ni location_pin mr-2"></i>| <span v-for="role,index in getUserInfo.role" :key="index">{{role | capitalizeAll}} | </span>
        </div>
        <div class="h5 mt-4">
          <i class="ni business_briefcase-24 mr-2"></i>
        </div>
        <!-- <div>
          <i class="ni education_hat mr-2"></i>University of Computer Science
        </div> -->
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import {getAge,capitalizeAll} from "../../../util/filters"
export default {
  computed: {
    ...mapGetters("user", ["getToken","getUserInfo"])
  },
   filters: { getAge,capitalizeAll }
};
</script>
<style></style>
